import { Component } from 'react';
import { ContentPlaceholder } from './ContentPlaceholder';

export interface IProps {
  height?: string;
  numTabs?: number;
  badges?: boolean;
}

export class PlaceholderTabs extends Component<IProps> {
  public render() {
    return (
      <ContentPlaceholder height={this.props.height}>
        {[...Array(this.props.numTabs || 3)].map((_, i) => (
          <rect key={i} y="30" x={20 + i * 60} rx="0" ry="0" width={'40px'} height={'20px'} />
        ))}
        <rect y="60" x={20} rx="0" ry="0" width={'40px'} height={'5px'} />
      </ContentPlaceholder>
    );
  }
}
